import { BaseError } from './base';

export function TimeoutError(message, debug, code, kinveyRequestId) {
  this.name = 'TimeoutError';
  this.message = message || 'The request timed out.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
TimeoutError.prototype = Object.create(BaseError.prototype);
TimeoutError.prototype.constructor = TimeoutError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/timeout.js